<div style='margin-top:2.0em;'>
	<div>
      Board Memberships
		<div *ngIf="isLoaded" class='results'>({{boards.length}})</div>
	</div>

	<div [ngClass]="{'hide':!display}">
		<loading *ngIf="!isLoaded"></loading>

		<div *ngIf="isLoaded">

			<div class='instructions' *ngIf='boards.length > 0'>
			    Registrant has following board memberships.
			</div>

			<div class='index'>
				<div class='row title'>
					<div *ngIf='boards.length === 0'></div>
					<div *ngIf='boards.length > 0'>
                        <div class='col-sm-12'>
                        <div class='col-sm-6'>Board Name</div>
                        <div class='col-sm-3'>Board ID</div>
                        <div class='col-sm-3'>Board Membership ID</div>
                        </div>
					</div>
				</div>

				<div class='row' *ngIf='boards.length === 0'>
					<div class='col-sm-12 text-center' style='padding:1.0em 0;'>
						<div *ngIf='!errorMessage'>
							No board info.
						</div>
						<div *ngIf='errorMessage'>
							{{errorMessage}}
						</div>
					</div>
				</div>

				<div class='row' *ngFor="let board of boards">
                    <div class='col-sm-12'>
                        <div class='col-sm-6'>{{board.casce_board.board_name}}</div>
                        <div class='col-sm-3'>{{board.casce_board.board_id}}</div>
                        <div class='col-sm-3'>{{board.board_membership_id}}</div>
                    </div>
				</div>
			</div>
		</div>
	</div>
</div>
<div style='margin-top:2.0em;'>
	<div>
      Licenses
		<div *ngIf="isLoaded" class='results'>({{licenses.length}})</div>
	</div>

	<div [ngClass]="{'hide':!display}">
		<loading *ngIf="!isLoaded"></loading>

		<div *ngIf="isLoaded">

			<div class='instructions' *ngIf='licenses.length > 0'>
				Registrant has following licenses.
			</div>

			<div class='index'>
				<div class='row title'>
					<div *ngIf='licenses.length === 0'></div>
					<div *ngIf='licenses.length > 0'>
                        <div class='col-sm-12'>
                        <div class='col-sm-6'>State</div>
                        <div class='col-sm-3'>License Type</div>
                        <div class='col-sm-3'>License Number</div>
                        </div>
					</div>
				</div>

				<div class='row' *ngIf='licenses.length === 0'>
					<div class='col-sm-12 text-center' style='padding:1.0em 0;'>
						<div *ngIf='!errorMessage'>
							No License info.
						</div>
						<div *ngIf='errorMessage'>
							{{errorMessage}}
						</div>
					</div>
				</div>

				<div class='row' *ngFor="let license of licenses">
                    <div class='col-sm-12'>
                        <div class='col-sm-6'>{{license.casce_state.state_name}}</div>
                        <div class='col-sm-3'>{{license.casce_license_type.license_type}}</div>
                        <div class='col-sm-3'>{{license.license_number}}</div>
                    </div>
				</div>
			</div>
            <div class='index'>
                <div class='row title'>
                    <div *ngIf='pars_person === null'></div>
                    <div *ngIf='pars_person !== null' class='col-sm-12'>
                        <div class='col-sm-4'>Birth Month</div>
                        <div class='col-sm-4'>Birth Day</div>
                        <div class='col-sm-4'>Transmit Consent</div>
                    </div>
                </div>
                <div class='row' *ngIf='pars_person === null'>
					<div class='col-sm-12 text-center' style='padding:1.0em 0;'>
						<div *ngIf='!errorMessage'>
							No birth month, day, and PARS reporting consent.
						</div>
						<div *ngIf='errorMessage'>
							{{errorMessage}}
						</div>
					</div>
				</div>
                <div *ngIf='pars_person !== null' class='row'>
                    <div class='col-sm-12'>
                        <div class='col-sm-4'>{{pars_person.birth_mm}}</div>
                        <div class='col-sm-4'>{{pars_person.birth_dd}}</div>
                        <div class='col-sm-4'>{{pars_person.transmit_consent == 1 ? "Yes" : "No"}}</div>
                    </div>
                </div>
            </div>
		</div>
	</div>
</div>
<div style='margin-top:2.0em;'></div>